module.exports = __webpack_public_path__ + "images/bg.png?6a19227ed22f07332128ab4ba81d2c6f";


//////////////////
// WEBPACK FOOTER
// ./src/images/background/bg.png
// module id = 5
// module chunks = 0 1